// Utils
import { getEndOfMonth } from './getEndOfMonth';
/**
 * @description Subtract the specified number of months from the given date.
 *
 * @param {Date} date The date from of which the months are to be subtracted.
 *
 * @param {number} numberOfMonths The number of months to subtract from the given date.
 *
 * @returns {Date} The updated date with the subtracted months.
 */
export var subtractMonths = function (date, numberOfMonths) {
    var dateToMutate = new Date(date);
    dateToMutate.setMonth(dateToMutate.getMonth() - numberOfMonths);
    var daysInTheGivenMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    var daysInTheResultingMonth = new Date(date.getFullYear(), date.getMonth() - numberOfMonths + 1, 0)
        .getDate();
    // If the given date does not exist in the resulting month, set the date to the last day of the resulting month.
    // Example: If the given date is 31st March, and we subtract one month, it would result it 31st Feb which translates
    // to 3rd of March. In this case we want to set the date to the last day of Feb.
    if (date.getDate() === getEndOfMonth(date).getDate() && daysInTheGivenMonth > daysInTheResultingMonth) {
        // Sets the date to the last day of the previous month.
        // @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setDate#description
        dateToMutate.setDate(0);
    }
    return dateToMutate;
};
//# sourceMappingURL=subtractMonths.js.map